import React from 'react';
import { createUseStyles } from 'react-jss';
import { Stack, StackItem } from '@fluentui/react';
import classNames from 'classnames';
import { PlaygroundTheme } from '../../Theme';
import { useIsVivara } from '../../hooks/useIsVivara';

const useStyles = createUseStyles<string, unknown, PlaygroundTheme>((theme) => ({
  welcomeMessageContainer: {
    margin: '30vh 0 20vh 0',
    color: theme.neutralPrimary,

    '& .title': {
      fontSize: '40px',
      fontWeight: 600,
      marginBottom: '20px',
    },

    '& .subTitle': {
      fontSize: '20px',
      fontWeight: 400,
    },

    '&.is-vivara': {
      color: theme.themePrimary,
      margin: '5vh 0 10vh 0',

      '& .title': {
        marginTop: '20px',
        marginBottom: '30px',
      },

      '& .subTitle': {
        margin: '0 10vw 0 10vw',
        textAlign: 'center',
      },
    },
  },
}));

interface IWelcomeMessageProps {
  title?: string;
  subTitle?: string;
  className?: string;
}

export const WelcomeMessage: React.FC<IWelcomeMessageProps> = ({ title, subTitle, className }) => {
  const classes = useStyles();
  const isVivara = useIsVivara();

  return (
    <Stack verticalAlign="center" horizontalAlign="center" className={classNames(isVivara && 'is-vivara', classes.welcomeMessageContainer, className)}>
      <StackItem>
        <div className="title">{title}</div>
      </StackItem>
      <StackItem>
        <div className="subTitle">{subTitle}</div>
      </StackItem>
    </Stack>
  );
};

WelcomeMessage.defaultProps = {
  title: 'Welcome to Playground!',
  subTitle: 'Enjoy your time',
};
